import { render } from "./SaveResource.vue?vue&type=template&id=2dc027e8&scoped=true"
import script from "./SaveResource.vue?vue&type=script&lang=js"
export * from "./SaveResource.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc027e8"]])

export default __exports__